import { Body, Button, Spacer } from '@spritz-finance/ui'
import { Row } from '../../../../../components/Layout/Row'
import { SubscriptionAccount } from './create/CreateSubscriptionButton'
import { useCreateSubscription } from './create/CreateSubscriptionProvider'

import { SubscriptionAllowance } from './SubscriptionAllowance'
import { SubscriptionDetails } from './SubscriptionDetails'
import { SubscriptionData } from './SubscriptionForm'

type SubscriptionConfirmationProps = {
    data: SubscriptionData
    account: SubscriptionAccount
    onClickBack: (data: SubscriptionData) => void
    toNextStep: () => void
}

export const SubscriptionConfirmation: React.VFC<SubscriptionConfirmationProps> = ({
    data,
    account,
    onClickBack,
    toNextStep,
}) => {
    const { token } = useCreateSubscription()
    return (
        <>
            <Row align="center">
                <Body.Bold size={18}>SMARTPay summary</Body.Bold>
            </Row>
            <Spacer height={16} />
            <SubscriptionDetails account={account} data={data} />
            <Spacer height={32} />
            <SubscriptionAllowance onProceed={toNextStep} token={token} />
            <Spacer height={16} />
            <Row align="center">
                <Button.Text onClick={() => onClickBack(data)}>Edit</Button.Text>
            </Row>
            <Spacer height={16} />
        </>
    )
}
